import { render } from "./UiBackButton.vue?vue&type=template&id=4fdb9bda"
import script from "./UiBackButton.vue?vue&type=script&lang=js"
export * from "./UiBackButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__